import React from 'react';

import {Avatar, Drawer, Table} from 'antd';
import moment from "moment";

const tableDefinition = {
	// 滚动设置
	scroll: { x: 800, y: window.innerHeight - 370 },
	// 表格列
	columns: [
		{
			title: "客户sap编码",
			dataIndex: "sap_no",
			key: "sap_no",
		},{
			title: '产品模式',
			dataIndex: 'guarantee_type',
			key: 'guarantee_type',
			width: 120,
			render: (text, record) => (
				<div>
					{text !== undefined && text !== null ? (
						<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
					) : (
						''
					)}
				</div>
			),
		}, {
			title: "授信类型",
			dataIndex: "credit_type",
			key: "credit_type",
		}, {
			title: "审核意见",
			dataIndex: "audit_opinion",
			key: "audit_opinion",
		}, {
			title: "审核结果",
			dataIndex: "audit_result",
			key: "audit_result",
			render: audit_result => (audit_result && (audit_result === "01" ? "成功" : (audit_result === "02" && "失败"))),
		}, {
			title: "审核时间",
			dataIndex: "audit_time",
			key: "audit_time",
			render: time => (time && moment(time).format("YYYY-MM-DD HH:mm")),
		}, {
			title: "最新额度（单位为元）",
			dataIndex: "credit_amount",
			key: "credit_amount",
			render: (text, record) => {
				// 检查授信类型是否不等于 "授信通知"
				if (record.credit_type !== "授信通知") {
					// 如果不等于，返回原始文本除以 100 的结果
					return text / 100;
				}
				// 如果等于，返回原始文本
				return text;
			},
			width: 200,
		}, {
			title: "社会信用代码",
			dataIndex: "social_credit_code",
			key: "social_credit_code",
		}
	]
}

const ClientCreditDrawer = (props) => {

	const { onClose, visible, value } = props

	// 是否有授信记录
	const hasCreditRecord = value && value.length > 0;
	// 有授信记录宽度较大，显示授信信息，否则显示小一些的未查询到授信信息
	const width = hasCreditRecord ? window.innerWidth * 0.75 : window.innerWidth * 0.25;

	return (

		<Drawer title={<span>客户授信信息</span>} placement="right" closable={false} onClose={onClose} visible={visible} width={width} >
			{
				hasCreditRecord ? (
					<Table {...tableDefinition} dataSource={value}>
					</Table>
				) : "未查询到授信信息"
			}

		</Drawer>

	)

}


export default ClientCreditDrawer;
